'use client'
import React, { PropsWithChildren } from 'react'
import styles from './styles.module.scss'

const Table: React.FC<PropsWithChildren> = props => {
  return <table className={styles.table} {...props} />
}

export default Table
